export enum IdDocumentType {
  DRIVER_LICENSE = 'DRIVER_LICENSE',
  HEALTH_INSURANCE = 'HEALTH_INSURANCE',
  PASSPORT = 'PASSPORT',
}

export interface IdDocument {
  type: IdDocumentType;
  code: string;
}
